module.exports = __webpack_public_path__ + "static/media/bigbackarrow.4303cfa7.svg";